var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWriteIconCamera(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\uB808\\uC774\\uC5B4_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "26px",
    height: "26px",
    viewBox: "0 0 26 26",
    style: {
      enableBackground: "new 0 0 26 26"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;}\r\n\t.st1{fill:#96A0B7;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "write-icon-camera",
    transform: "translate(1 2)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_36",
    x: -1,
    y: -2,
    className: "st0",
    width: 26,
    height: 26
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_42",
    transform: "translate(-1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_36",
    className: "st1",
    d: "M23.1,3.6h-3.7c-0.2,0-0.3-0.1-0.4-0.2l-1-1.9C17.4,0.6,16.5,0,15.4,0h-4.8 C9.5,0,8.6,0.6,8,1.5L7,3.4C6.9,3.5,6.8,3.6,6.6,3.6H2.9C1.3,3.6,0,4.9,0,6.5v11.7c0,1.6,1.3,2.9,2.9,2.9h20.1 c1.6,0,2.9-1.3,2.9-2.9V6.5C26,4.9,24.7,3.6,23.1,3.6 M13,17.8c-3,0-5.5-2.4-5.5-5.5S10,6.9,13,6.9s5.5,2.4,5.5,5.5v0 C18.4,15.4,16,17.8,13,17.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_37",
    className: "st1",
    d: "M13,9.5c1.6,0,2.9,1.3,2.9,2.9s-1.3,2.9-2.9,2.9s-2.9-1.3-2.9-2.9S11.4,9.5,13,9.5"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWriteIconCamera);
export default __webpack_public_path__ + "static/media/write-icon-camera.a41e23395878b346c9d89f2b330ea10f.svg";
export { ForwardRef as ReactComponent };